import { Label } from '@creanizer/ui'
import { Alert, AlertDescription } from '@creanizer/ui'
import { Info, Swords } from 'lucide-react'
import type { CommunityInput, SavedEnemy } from '@creanizer/types'
import { generateEnemyContext } from '@creanizer/utils'

interface EnemyContextFormProps {
  input: CommunityInput
  onChange: (input: CommunityInput) => void
  enemies?: SavedEnemy[]
}

export function EnemyContextForm({
  input,
  onChange,
  enemies = [],
}: EnemyContextFormProps) {
  const handleEnemySelect = (enemyIds: string[]) => {
    const selectedEnemies = enemies.filter(e => enemyIds.includes(e.id))
    const contexts = selectedEnemies.map(enemy => generateEnemyContext(enemy))
    
    onChange({
      ...input,
      enemyIds: enemyIds,
      enemyContext: contexts.length > 0 ? contexts.join('\n\n') : undefined
    })
  }

  return (
    <div className="space-y-4">
      <Alert>
        <Info className="h-4 w-4" />
        <AlertDescription>
          エネミーや怪異の出没地、伝承のある場所としてコミュニティを生成します。
          選択されたエネミーの脅威や特性が反映された場所が作られます。
        </AlertDescription>
      </Alert>

      {enemies.length > 0 ? (
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <Swords className="h-4 w-4" />
            <Label>関連エネミー・怪異（複数選択可）</Label>
          </div>
          <div className="grid grid-cols-2 gap-2 max-h-40 overflow-y-auto border rounded-md p-2">
            {enemies.map((enemy) => (
              <label
                key={enemy.id}
                className="flex items-center space-x-2 p-2 border rounded cursor-pointer hover:bg-accent transition-colors"
              >
                <input
                  type="checkbox"
                  checked={input.enemyIds?.includes(enemy.id) || false}
                  onChange={(e) => {
                    const ids = input.enemyIds || []
                    const newIds = e.target.checked
                      ? [...ids, enemy.id]
                      : ids.filter(id => id !== enemy.id)
                    handleEnemySelect(newIds)
                  }}
                  className="rounded"
                />
                <span className="text-sm truncate" title={enemy.title}>
                  {enemy.title}
                </span>
              </label>
            ))}
          </div>
          {input.enemyIds && input.enemyIds.length > 0 && (
            <p className="text-xs text-muted-foreground">
              選択中: {input.enemyIds.length}体のエネミー
            </p>
          )}
        </div>
      ) : (
        <Alert>
          <AlertDescription className="text-muted-foreground">
            保存済みのエネミーがありません。
            エネミージェネレータでエネミーを作成してから連携してください。
          </AlertDescription>
        </Alert>
      )}
    </div>
  )
}